<template>
  <div class="project-detail-container">
    <!-- 主要内容区域 -->
    <div class="main-content">
      <!-- 左侧卡片 -->
      <div class="left-panel">
        <div class="project-card">
          <!-- 项目名称 -->
          <div class="project-name">
            <h2>{{ projectInfo.name }}</h2>
          </div>
          
          <!-- 退出项目按钮 -->
          <div class="exit-section">
            <el-button 
              type="primary" 
              @click="handleExitProject"
              class="exit-btn"
            >
              <el-icon><ArrowLeft /></el-icon>
              退出项目
            </el-button>
          </div>

          <!-- 统计卡片区域 -->
          <div class="stats-cards-left">
            <div class="stats-row-left">
              <div class="stat-card-left">
                <div class="stat-title-left">当月到货清单</div>
                <div class="stat-value-left">12</div>
              </div>
              <div class="stat-card-left">
                <div class="stat-title-left">当月到货金额</div>
                <div class="stat-value-left">¥ 85,600</div>
              </div>
            </div>
            <div class="stats-row-left">
              <div class="stat-card-left">
                <div class="stat-title-left">累计到货清单</div>
                <div class="stat-value-left">156</div>
              </div>
              <div class="stat-card-left">
                <div class="stat-title-left">累计到货金额</div>
                <div class="stat-value-left">¥ 1,256,800</div>
              </div>
            </div>
            <div class="stats-row-left">
              <div class="stat-card-left">
                <div class="stat-title-left">批次敦到货清单</div>
                <div class="stat-value-left">8</div>
              </div>
              <div class="stat-card-left">
                <div class="stat-title-left">申请批次款金额</div>
                <div class="stat-value-left">¥ 450,000</div>
              </div>
            </div>
          </div>

          <!-- 项目信息卡片 -->
          <div class="info-card-container">
            <div class="info-card">
              <div class="info-card-header">
                <h4>项目信息</h4>
              </div>
              <div class="info-card-content">
                <div class="info-grid">
                  <div class="info-item">
                    <div class="info-label">
                      <el-icon><User /></el-icon>
                      <span>项目负责人</span>
                    </div>
                    <div class="info-value">
                      <div class="user-list">
                        <el-tag
                          v-for="userId in getUserIds(projectInfo.user)"
                          :key="userId"
                          size="small"
                          class="user-tag">
                          {{ getEmployeeName(userId) }}
                        </el-tag>
                      </div>
                    </div>
                  </div>
                  
                  <div class="info-item">
                    <div class="info-label">
                      <el-icon><Location /></el-icon>
                      <span>位置信息</span>
                    </div>
                    <div class="info-value">
                      {{ projectInfo.location || '未设置' }}
                    </div>
                  </div>
                  
                  <div class="info-item">
                    <div class="info-label">
                      <el-icon><Calendar /></el-icon>
                      <span>创建时间</span>
                    </div>
                    <div class="info-value">
                      {{ formatDate(projectInfo.createtime) }}
                    </div>
                  </div>
                  
                  <div class="info-item">
                    <div class="info-label">
                      <el-icon><Phone /></el-icon>
                      <span>甲方联系人</span>
                    </div>
                    <div class="info-value">
                      <div>{{ projectInfo.client_contact_person || '未设置' }}</div>
                      <div class="contact-phone">{{ projectInfo.client_contact_phone || '' }}</div>
                    </div>
                  </div>
                  
                  <div class="info-item">
                    <div class="info-label">
                      <el-icon><OfficeBuilding /></el-icon>
                      <span>精装单位</span>
                    </div>
                    <div class="info-value">
                      <div>{{ projectInfo.decoration_contact_person || '未设置' }}</div>
                      <div class="contact-phone">{{ projectInfo.decoration_contact_phone || '' }}</div>
                    </div>
                  </div>
                  
                  <div class="info-item full-width" v-if="projectInfo.remarks">
                    <div class="info-label">
                      <el-icon><Document /></el-icon>
                      <span>项目备注</span>
                    </div>
                    <div class="info-value">
                      {{ projectInfo.remarks }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧内容区域 -->
      <div class="right-panel">
        <!-- 标签页卡片 -->
        

        <!-- 待办事项组件 -->
        <TodoList 
          :is-admin="isAdmin"
          :project-id="projectId"
        />
        <div class="tabs-card">
          <el-tabs v-model="activeTab" class="project-tabs">
            <el-tab-pane label="项目详情" name="detail">
              <div class="tab-content">
                <!-- 统计卡片区域 -->
                <div class="stats-cards">
                  <div class="stats-row">
                    <div class="stat-card">
                      <div class="stat-title">当月到货清单</div>
                      <div class="stat-value">12</div>
                    </div>
                    <div class="stat-card">
                      <div class="stat-title">当月到货金额</div>
                      <div class="stat-value">¥ 85,600</div>
                    </div>
                  </div>
                  <div class="stats-row">
                    <div class="stat-card">
                      <div class="stat-title">累计到货清单</div>
                      <div class="stat-value">156</div>
                    </div>
                    <div class="stat-card">
                      <div class="stat-title">累计到货金额</div>
                      <div class="stat-value">¥ 1,256,800</div>
                    </div>
                  </div>
                  <div class="stats-row">
                    <div class="stat-card">
                      <div class="stat-title">批次敦到货清单</div>
                      <div class="stat-value">8</div>
                    </div>
                    <div class="stat-card">
                      <div class="stat-title">申请批次款金额</div>
                      <div class="stat-value">¥ 450,000</div>
                    </div>
                  </div>
                </div>

                
              </div>
            </el-tab-pane>
            
            <el-tab-pane label="甲方下单信息" name="order">
              <div class="tab-content">
                <!-- 甲方下单信息内容 -->
                <p>甲方下单信息内容区域</p>
              </div>
            </el-tab-pane>
            
            <el-tab-pane label="排产信息" name="production">
              <div class="tab-content">
                <!-- 排产信息内容 -->
                <p>排产信息内容区域</p>
              </div>
            </el-tab-pane>
            
            <el-tab-pane label="入库信息" name="storage">
              <div class="tab-content">
                <!-- 入库信息内容 -->
                <p>入库信息内容区域</p>
              </div>
            </el-tab-pane>
            
            <el-tab-pane label="报损信息" name="damage">
              <div class="tab-content">
                <!-- 报损信息内容 -->
                <p>报损信息内容区域</p>
              </div>
            </el-tab-pane>
            
            <el-tab-pane label="汇款信息" name="payment">
              <div class="tab-content">
                <!-- 汇款信息内容 -->
                <p>汇款信息内容区域</p>
              </div>
            </el-tab-pane>
            
            <el-tab-pane label="物流信息" name="logistics">
              <div class="tab-content">
                <!-- 物流信息内容 -->
                <p>物流信息内容区域</p>
              </div>
            </el-tab-pane>
            
            <el-tab-pane label="关联台账" name="ledger">
              <div class="tab-content">
                <!-- 关联台账内容 -->
                <p>关联台账内容区域</p>
              </div>
            </el-tab-pane>
          </el-tabs>
        
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus'
import { ArrowLeft, ArrowDown, User, Location, Calendar, Phone, OfficeBuilding, Document } from '@element-plus/icons-vue'
import TodoList from '../components/TodoList.vue'

export default {
  name: 'ProjectDetail',
  components: {
    ArrowLeft,
    ArrowDown,
    User,
    Location,
    Calendar,
    Phone,
    OfficeBuilding,
    Document,
    TodoList
  },
  data() {
    return {
      projectId: null,
      projectInfo: {},
      employeeList: [],
      userName: '管理员',
      userAvatar: '',
      activeTab: 'detail',
      isAdmin: true  // 这里需要根据实际用户权限设置
    }
  },
  mounted() {
    this.projectId = this.$route.params.id
    this.loadProjectDetail()
    this.getEmployeeList()
    this.getUserInfo()
  },
  methods: {
    // 加载项目详情
    async loadProjectDetail() {
      try {
        const response = await this.$axios.get(`/api/project/getinfo`, {
          params: { id: this.projectId }
        })
        if (response.code === 1) {
          this.projectInfo = response.data || {}
        } else {
          ElMessage.error(response.msg || '获取项目详情失败')
        }
      } catch (error) {
        console.error('获取项目详情失败:', error)
        ElMessage.error('获取项目详情失败')
      }
    },

    // 获取员工列表
    async getEmployeeList() {
      try {
        const response = await this.$axios.get('/api/employee/getlist')
        if (response.code === 1) {
          this.employeeList = response.data || []
        }
      } catch (error) {
        console.error('获取员工列表失败:', error)
      }
    },

    // 获取用户信息
    getUserInfo() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
      this.userName = userInfo.name || '管理员'
      this.userAvatar = userInfo.avatar || ''
    },

    // 退出项目
    handleExitProject() {
      this.$router.go(-1)
    },


    // 获取员工名称
    getEmployeeName(userId) {
      const emp = this.employeeList.find(item => item.id == userId)
      return emp ? emp.name : '未知员工'
    },

    // 将负责人字符串转换为数组
    getUserIds(userString) {
      if (!userString) return []
      return userString.split(',').filter(id => id.trim())
    },

    // 格式化日期
    formatDate(timestamp) {
      if (!timestamp) return '-'
      const date = new Date(timestamp * 1000)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    }
  }
}
</script>

<style scoped>
.project-detail-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f7fa;
}


/* 主要内容区域 */
.main-content {
  flex: 1;
  display: flex;
  gap: 20px;
  padding: 20px;
  overflow: hidden;
}

/* 左侧面板 */
.left-panel {
  width: 320px;
  flex-shrink: 0;
}

.project-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
}

.project-name {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e4e7ed;
}

.project-name h2 {
  margin: 0;
  color: #303133;
  font-size: 20px;
  font-weight: bold;
}

.exit-section {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e4e7ed;
}

.exit-btn {
  width: 100%;
}

.project-details {
  flex: 1;
  overflow-y: auto;
}

.detail-item {
  margin-bottom: 15px;
  padding: 8px 0;
}

.detail-item .label {
  font-weight: bold;
  color: #606266;
  font-size: 14px;
  display: block;
  margin-bottom: 4px;
}

.detail-item .value {
  color: #303133;
  font-size: 14px;
  line-height: 1.4;
}

.user-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.user-tag {
  margin: 2px;
}

/* 左侧统计卡片样式 */
.stats-cards-left {
  margin-bottom: 20px;
}

.stats-row-left {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.stat-card-left {
  flex: 1;
  background: white;
  border-radius: 8px;
  padding: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
  border: 1px solid #e4e7ed;
}

.stat-title-left {
  font-size: 12px;
  color: #606266;
  margin-bottom: 6px;
  font-weight: 500;
}

.stat-value-left {
  font-size: 16px;
  color: #303133;
  font-weight: bold;
}

/* 右侧面板 */
.right-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.todo-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
}

.todo-card .card-header {
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e4e7ed;
}

.todo-card .card-header h3 {
  margin: 0;
  color: #303133;
  font-size: 16px;
}

.todo-content {
  max-height: 200px;
  overflow-y: auto;
}

.todo-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.todo-item:last-child {
  border-bottom: none;
}

.todo-date {
  font-size: 12px;
  color: #909399;
}

.no-todo {
  text-align: center;
  color: #909399;
  font-size: 14px;
  padding: 20px 0;
}

.tabs-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  flex: 1;
  overflow: hidden;
}

.project-tabs {

  display: flex;
  flex-direction: column;
}

.project-tabs :deep(.el-tabs__header) {
  margin: 0;
  padding: 0 20px;
  background: #f8f9fa;
  order: 1;
}

.project-tabs :deep(.el-tabs__content) {
  flex: 1;
  padding: 0;
  order: 2;
}

.tab-content {
  padding: 20px;
  height: 100%;
  overflow-y: auto;
}

.tab-content p {
  margin: 0;
  color: #909399;
  text-align: center;
  line-height: 200px;
}

/* 统计卡片样式 */
.stats-cards {
  margin-bottom: 20px;
}

.stats-row {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.stat-card {
  flex: 1;
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  text-align: center;
  border: 1px solid #e4e7ed;
}

.stat-title {
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
  font-weight: 500;
}

.stat-value {
  font-size: 24px;
  color: #303133;
  font-weight: bold;
}

/* 信息卡片样式 */
.info-card-container {
  margin-top: 20px;
}

.info-card {
  background: white;
  border-radius: 8px;
  border: 1px solid #e4e7ed;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.info-card-header {
  padding: 16px 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #e4e7ed;
}

.info-card-header h4 {
  margin: 0;
  color: #303133;
  font-size: 16px;
  font-weight: bold;
}

.info-card-content {
  padding: 20px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 16px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.info-item.full-width {
  grid-column: 1 / -1;
}

.info-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #606266;
  font-weight: 500;
}

.info-label .el-icon {
  font-size: 14px;
  color: #409EFF;
}

.info-value {
  font-size: 14px;
  color: #303133;
  line-height: 1.4;
}

.contact-phone {
  font-size: 12px;
  color: #909399;
  margin-top: 2px;
}

/* 项目详细信息卡片样式 */
.project-info-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e4e7ed;
}

.project-info-card .card-header {
  padding: 16px 20px;
  border-bottom: 1px solid #e4e7ed;
  background: #f8f9fa;
  border-radius: 8px 8px 0 0;
}

.project-info-card .card-header h3 {
  margin: 0;
  color: #303133;
  font-size: 16px;
  font-weight: bold;
}

.info-content {
  padding: 20px;
}

.info-row {
  display: flex;
  gap: 20px;
  margin-bottom: 16px;
}

.info-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-item.full-width {
  flex: 0 0 100%;
}

.info-label {
  font-weight: bold;
  color: #606266;
  font-size: 14px;
}

.info-value {
  color: #303133;
  font-size: 14px;
  line-height: 1.4;
}
</style>
